const Helper = {
  getUniqueList: (data, name) => {
    let arr = data
      .map((e, i) => data[i][name])
      .filter((v, i, a) => a.indexOf(v) === i)
      .filter((e) => e);
    return arr;
  },
  getSum: (data, name) => {
    let sum = data.map((e) => e[name]).reduce((a, b) => a + b, 0);

    return sum;
  },
  getFilteredData: (data, type, name) => {
    let filteredData = data.filter((e) => e[type] === name);

    return filteredData;
  },
  finalData: (data, list, type, firstKey, upperBound) => {
    let final_data = [];

    for (let i = 0; i < list.length; i++) {
      let obj = {};
      let filteredData = Helper.getFilteredData(data, type, list[i]);

      let mx = ((upperBound * filteredData.length) / data.length).toFixed(2);

      obj[firstKey] = list[i];
      obj["min"] = (0).toString();
      obj["max"] = mx > 1 ? "1" : mx.toString();

      final_data.push(obj);
    }
    return final_data;
  },

  // setting universe_lite limit step slider values
  getLimitsDataFromSymbols: (data, max_val) => {
    let upperBound = max_val ? max_val * 1 : 0;
    let listOfFundType = Helper.getUniqueList(data, "new_fund_type");
    let listOfClassification = Helper.getUniqueList(data, "new_classification");
    let listOfAssetClass = Helper.getUniqueList(data, "fund_asset_class_focus");
    let listOfStyle = Helper.getUniqueList(data, "new_style");

    let FundType = Helper.finalData(
      data,
      listOfFundType,
      "new_fund_type",
      "name",
      upperBound
    );
    let Classification = Helper.finalData(
      data,
      listOfClassification,
      "new_classification",
      "name",
      upperBound
    );
    let AssetClass = Helper.finalData(
      data,
      listOfAssetClass,
      "fund_asset_class_focus",
      "name",
      upperBound
    );
    let Style = Helper.finalData(
      data,
      listOfStyle,
      "new_style",
      "style",
      upperBound
    );

    return {
      fund_type: FundType,
      asset_class: Classification,
      overall_focus: AssetClass,
      styles: Style,
    };
  },

  // excel numeric date to js date formatter
  ExcelDateToJSDate: (date) => {
    return new Date(Math.round((date - 25569) * 86400 * 1000));
  },
};

export default Helper;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/helper/Helper.js